import type { ButtonHTMLAttributes } from 'react';
import styles from './FloraToggleButton.module.css';

interface FloraToggleButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
	active?: boolean;
	size?: 'md' | 'lg';
}

export const FloraToggleButton = ({ active, size = 'md', className, children, ...rest }: FloraToggleButtonProps) => {
	const classes = [styles.button, active ? styles.active : '', size === 'lg' ? styles.lg : '', className]
		.filter(Boolean)
		.join(' ');

	return (
		<button type="button" className={classes} {...rest}>
			{children}
		</button>
	);
};
